import { render, staticRenderFns } from "./createSystem.vue?vue&type=template&id=7cd5085b&"
import script from "./createSystem.vue?vue&type=script&lang=js&"
export * from "./createSystem.vue?vue&type=script&lang=js&"
import style0 from "./createSystem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports